export default __webpack_public_path__ + "static/media/deleteicon.6d08f094.svg";